export const PASSPORT = 'PASSPORT';
export const PASSPORT_STATUS = 'PASSPORT_STATUS';
export const passportTags = ['Passport', 'Passport_Status'];
